<template>
  <div>
    <template v-if="step === 1">
      <el-row type="flex" class="my-2">
        <el-col :span="24">
          <div class="text-center">
            <p>
              Please provide your email address
            </p>
          </div>
        </el-col>
      </el-row>
      <el-form :model="form" label-position="top" ref="form">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="Email" prop="email" :rules="emailField()">
              <el-input
                v-model="form.email"
                type="text"
                required
                @focus="changeColor($event)"
                @blur="resetColor($event)"
                :disabled="preview"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-button
              class="authx-button w-100"
              type="primary"
              :loading="loading"
              :disabled="preview"
              @click="forgotPassword"
              >Next</el-button
            >
            <el-button
              class="w-100"
              type="text"
              @click="$emit('navigate', 'login')"
            >
              <i class="ra-icon--chevron-left"></i> Back to login
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template v-else-if="step === 2">
      <form-reset-password
        :validation="validation"
        :token.sync="token"
        :domain-data="domainData"
        :colors="colors"
        @navigate="$emit('navigate', $event)"
      />
    </template>
  </div>
</template>

<script>
import { currentUser } from "@/lib/utils";
import FormResetPassword from "@/components/Products/AuthX/Widget/Forms/FormResetPassword.vue";

export default {
  name: "FormForgotPassword",

  components: {
    FormResetPassword
  },

  props: {
    domainData: {
      type: Object,
      default() {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    validation: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      radiusUser: currentUser(),
      loading: false,
      step: 1,
      form: {
        email: ""
      },
      token: ""
    };
  },

  inject: ["preview"],

  computed: {
    preview() {
      return this.preview;
    }
  },

  created() {
    this.setPrimaryColour();
  },

  methods: {
    resetColor(evt) {
      evt.target.style.borderColor = "#dcdfe6";
    },

    changeColor(evt) {
      evt.target.style.borderColor = this.colors.secondary;
    },

    forgotPassword() {
      this.loading = true;
      this.$refs.form.validate(async valid => {
        if (!valid || this.radiusUser) {
          this.loading = false;
          return false;
        }

        const identifier = this.form.email;

        this.$http
          .post(
            "apps/password/forgot",
            {
              body: {
                identifier: identifier
              },
              method: "POST"
            },
            {
              headers: {
                "Session-Token": this.domainData.sessionToken
              }
            }
          )
          .then(response => {
            this.loading = false;
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              this.notification(
                "OTP Code",
                "OTP is sent for password reset!",
                "success"
              );
              this.token = resData.token;
              this.step = 2;
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    sendOtp() {
      this.loading = true;
      this.$refs.form.validate(async valid => {
        if (!valid || this.radiusUser) {
          this.loading = false;
          return false;
        }

        const identifier = this.form.email;

        this.$http
          .post(
            "apps/password/forgot",
            {
              body: {
                identifier: identifier
              },
              method: "POST"
            },
            {
              headers: {
                "Session-Token": this.domainData.sessionToken
              }
            }
          )
          .then(response => {
            this.loading = false;
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              this.notification(
                "OTP Code",
                "Request for OTP is successful! An OTP has been sent to your email for verification",
                "success"
              );
              this.token = resData.token;
              this.step = 2;
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    setPrimaryColourToLink() {
      const termsLinks = document.querySelectorAll(".authx-form a");
      termsLinks.forEach(link => {
        link.style.color = this.colors.secondary;
      });
    },

    setPrimaryColour() {
      const primaryColor = `${this.colors.primary}`;
      const buttons = document.querySelectorAll(
        ".authx-button.el-button--primary"
      );
      buttons.forEach(button => {
        button.style.background = primaryColor;
        button.style.borderColor = primaryColor;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
